import { FC } from 'react';
import { usePlaylistSync } from '../../hooks/usePlaylistSync';

/**
 * Invisible component that manages playlist synchronization
 * between local storage and Firestore based on user authentication state
 */
export const PlaylistSyncManager: FC = () => {
  // This hook handles all the logic
  usePlaylistSync();
  
  // This component doesn't render anything
  return null;
}; 